<div class="banner-title">
  <h1>Welcome  to <span>Moving Picture Club</span></h1>
  <h2 style="font-size: 2em;">Movies at your fingertip</h2> 
</div>
<ul class="gallery"> 
    <li style="padding:0px;margin:0px"*ngFor="let movieUrl of movieBannerList;let i = index" [style.background-image] = "movieUrl" class="background-image"></li>
  <!-- <li class="background-image" style="background-image: url(https://image.tmdb.org/t/p/original/drulhSX7P5TQlEMQZ3JoXKSDEfz.jpg);"></li>
  <li class="background-image" style="background-image: url(https://image.tmdb.org/t/p/original/drulhSX7P5TQlEMQZ3JoXKSDEfz.jpg);"></li>
  <li class="background-image" style="background-image: url(https://image.tmdb.org/t/p/original/drulhSX7P5TQlEMQZ3JoXKSDEfz.jpg);"></li> -->
</ul>
<app-search></app-search> 
